export const removeSpaces = (value?: string) => value?.replace(/\s+/g, ' ');
